/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Общий вид баннеров
   */
  app.ChponkPackView = app.ChponkView.extend({
    bannerData: '',
    chponckSelector: '.chponck-item',
    additionalOptions: ['mainWindow', 'eventBus', 'chponckSelector'],
    beforeRun: function () {
      this.chponcks = this.$(this.chponckSelector);
      app.ChponkView.prototype.beforeRun.apply(this, arguments);
    },
    /**
     * Установка данных слайда баннеров как данные баннера
     *
     * @private
     */
    _setBannerData: function () {
      this.bannerData = this._createKey(this.chponcks);
    },
    /**
     * @inheritDoc
     */
    _setCarouserListener: function () {
      var parent = this.$el.parent(),
        isOwlChponk = parent.hasClass('owl-item'),
        isCssChponk = parent.hasClass('carousel-item');
      if (isOwlChponk || isCssChponk) {
        this.visibilityFlag = (isOwlChponk && parent.hasClass('active'))
          || (isCssChponk && parent.css('opacity') === 1);
        this.listenTo(this.eventBus, 'carousel.changed.item', this.changeCarouselBanner);
      }
    },
    /**
     * @inheritDoc
     */
    _createKey: function ($elements) {
      var result = [];
      $elements.each(function (index, item) {
        result.push(this.getBannerDataAttributes(this.$(item)).id);
      }.bind(this));
      return result.join('_');
    },
    /**
     * @inheritDoc
     */
    changeCarouselBanner: function (e) {
      var $pack = $($(e).children()[0]),
        chponkData = this._createKey($pack.find(this.chponckSelector));
      if (chponkData !== this.bannerData) {
        return;
      }
      this.visibilityFlag = true;
      this.showListening(window);
      this.changeViewport(this.viewPortModel);

    },
    /**
     * @inheritDoc
     */
    inViewPort: function () {
      // если элемент не виден то ничего не отправляем
      if (!this.isVisible()) {
        return;
      }
      if (this.sent.indexOf(this.bannerData) === -1) {
        // Отписываемся от событий перед отправкой в око
        this.stopAllListening();
        this.chponcks.each(function (index, item) {
          app.helpers.OkoHelper.push(_.merge({
            n: 'banner',
          }, this.getBannerDataAttributes($(item))));
        }.bind(this));
        this.sent.push(this.bannerData);
      }
    },
    /**
     * @inheritDoc
     */
    getBannerDataAttributesError: function () {
      var errors = [];
      this.chponcks.length === 0 && errors.push('Отсутствуют баннера в блоке');
      this.chponcks.each(function (index, item) {
        var data = this.getBannerDataAttributes(this.$(item));
        if (!data['id']) {
          errors.push('Не указан ID баннера');
        }
        if (!data['num']) {
          errors.push('Не указан номер баннера');
        }
        if (!data['url'].length) {
          errors.push('Не указан URL баннера');
        }
        if (!data['place_id']) {
          errors.push('Не указана позиция баннера');
        }
      }.bind(this));
      return errors;
    },
  });
})();

}.call(window));